import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

document.documentElement.lang = "es";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Registro del Service Worker (solo en producción build).
const SW_VER = "156";

if ("serviceWorker" in navigator && window.location.hostname !== "localhost") {
  const ready = localStorage.getItem("deca_sw") === SW_VER;
  if (!ready) {
    localStorage.setItem("deca_sw", SW_VER);
    Promise.resolve()
      .then(() => navigator.serviceWorker.getRegistrations())
      .then((regs) => Promise.all(regs.map((r) => r.unregister())))
      .then(() => caches.keys())
      .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
      .finally(() => window.location.reload());
  } else {
    navigator.serviceWorker.register("/service-worker.js?v=" + SW_VER, { updateViaCache: "none" })
      .then((reg) => { try { reg.update(); } catch (_) { /* ignore */ } })
      .catch(() => {});
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (sessionStorage.getItem("deca_sw_reload") === SW_VER) return;
      sessionStorage.setItem("deca_sw_reload", SW_VER);
      window.location.reload();
    });
  }
}
